var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91663 5C5.91663 4.58579 6.25241 4.25 6.66663 4.25H17.5C17.9142 4.25 18.25 4.58579 18.25 5C18.25 5.41421 17.9142 5.75 17.5 5.75H6.66663C6.25241 5.75 5.91663 5.41421 5.91663 5Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91663 10C5.91663 9.58579 6.25241 9.25 6.66663 9.25H17.5C17.9142 9.25 18.25 9.58579 18.25 10C18.25 10.4142 17.9142 10.75 17.5 10.75H6.66663C6.25241 10.75 5.91663 10.4142 5.91663 10Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91663 15C5.91663 14.5858 6.25241 14.25 6.66663 14.25H17.5C17.9142 14.25 18.25 14.5858 18.25 15C18.25 15.4142 17.9142 15.75 17.5 15.75H6.66663C6.25241 15.75 5.91663 15.4142 5.91663 15Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 4.99935C1.66663 4.53911 2.03972 4.16602 2.49996 4.16602H2.50829C2.96853 4.16602 3.34163 4.53911 3.34163 4.99935C3.34163 5.45959 2.96853 5.83268 2.50829 5.83268H2.49996C2.03972 5.83268 1.66663 5.45959 1.66663 4.99935Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 9.99935C1.66663 9.53911 2.03972 9.16602 2.49996 9.16602H2.50829C2.96853 9.16602 3.34163 9.53911 3.34163 9.99935C3.34163 10.4596 2.96853 10.8327 2.50829 10.8327H2.49996C2.03972 10.8327 1.66663 10.4596 1.66663 9.99935Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 14.9993C1.66663 14.5391 2.03972 14.166 2.49996 14.166H2.50829C2.96853 14.166 3.34163 14.5391 3.34163 14.9993C3.34163 15.4596 2.96853 15.8327 2.50829 15.8327H2.49996C2.03972 15.8327 1.66663 15.4596 1.66663 14.9993Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuList);
export default __webpack_public_path__ + "static/media/menu-list.d933978d804f60fb3e0228f58c652660.svg";
export { ForwardRef as ReactComponent };